import React from 'react'

interface Finding { text: string; count: number }
interface Session { controlResultId?: number; records: Record<string, any[]>; label?: string }

export function getSessionFindings(session: Session | null): Finding[] | null {
    if (!session?.controlResultId) return null
    // Only use the selected session's exact handler result, never the latest result for the control.
    const handler = (session.records.handler || []).find(record =>
        Number(record.control_result_id ?? record.metadata_json?.control_result_id) === session.controlResultId)
    const findings = handler?.new_findings
    if (!Array.isArray(findings) || findings.some(finding => !finding || typeof finding.text !== 'string'
        || typeof finding.count !== 'number' || !Number.isFinite(finding.count) || finding.count < 0)) return null
    return findings
}

export const SessionFindings = ({ current }: { current: Session | null }) => {
    const findings = getSessionFindings(current)

    return <details className="session-findings">
        <summary>
            <span className="session-findings-title">Findings</span>
            {(findings === null || findings.length === 0) && <span className="session-findings-summary">
                {findings === null ? 'Unavailable for this session' : 'No findings'}
            </span>}
        </summary>
        <div className="session-findings-body">
            {findings === null ? <p>Findings are not available for this session.</p>
                : findings.length === 0 ? <p>No findings for this session.</p>
                : <div className="session-findings-scroll">
                    <ul className="session-findings-list" aria-label="Session findings">
                        {findings.map((finding, index) => <li className="session-finding" key={`${finding.text}:${index}`}>
                            <span className="session-finding-text">{finding.text}</span>
                            <span className="session-finding-count" aria-label={`Count: ${finding.count}`}>{finding.count}</span>
                        </li>)}
                    </ul>
                </div>}
        </div>
    </details>
}
